import ImmutableRenderComponent from './immutable-render-component';

import React from 'react';

/**
 * Component to display Error Messages for Aristo Demo app.
 */
export default class Error extends ImmutableRenderComponent {
  static get propTypes() {
    return {
      title: React.PropTypes.string.isRequired,
      error: React.PropTypes.string.isRequired,
    };
  }

  /**
   * Renders the error with the passed title and error message in an error-message class.
   */
  render() {
    return (
      <div className="error-message">
        <h3 className="bold text-left">{this.props.title}</h3>
        <p className="text-left">{this.props.error}</p>
      </div>);
  }
}
